import { Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
})
export class WelcomeComponent implements OnInit {
  themeService: ThemeService;

  constructor(
    themeService: ThemeService,
    public dialogRef: MatDialogRef<WelcomeComponent>
  ) {
    this.themeService = themeService;
  }

  ngOnInit() {}

  close(goToLogin: boolean) {
    localStorage.setItem('welcome', 'true');
    this.dialogRef.close(goToLogin);
  }
}
